module.exports = __webpack_public_path__ + "img/facebook.496a29aa.svg";